import * as React from "react";

export const Edit = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6568 3.19165C11.9748 2.87368 12.4903 2.87368 12.8083 3.19165C13.1263 3.50962 13.1263 4.02515 12.8083 4.34312L12.2326 4.91886L11.0811 3.76739L11.6568 3.19165ZM9.80829 3.34312L10.8083 2.34312C11.5949 1.55652 12.8702 1.55652 13.6568 2.34312C14.4434 3.12972 14.4434 4.40505 13.6568 5.19165L12.6568 6.19165L7.23056 11.6179C6.80495 12.0435 6.31351 12.3977 5.77516 12.6669L2.76922 14.1699C2.16753 14.4707 1.52922 13.8324 1.83007 13.2307L3.33304 10.2248C3.60222 9.68643 3.95643 9.19499 4.38203 8.76939L9.80829 3.34312ZM11.384 5.76739L6.38203 10.7694C6.04763 11.1038 5.6615 11.3821 5.2385 11.5936L3.5742 12.4257L4.40635 10.7614C4.61785 10.3384 4.89616 9.95232 5.23056 9.61791L10.2326 4.61592L11.384 5.76739Z"
    />
);
